import React, { memo } from 'react';
export function PainSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center" data-id="element-140">
          La verità che nessuno dice
        </h2>
        <div className="space-y-6 text-gray-700 text-lg sm:text-xl mb-12" data-id="element-141">
          <p className="font-semibold text-2xl text-gray-900" data-id="element-142">
            Non è solo dimenticanza. È la sensazione di perdere una parte di sé.
          </p>
          <p data-id="element-143">
            Hai mai aperto un cassetto e dimenticato perché eri lì? Hai mai
            esitato davanti a un nome familiare? Non è solo memoria: è
            autonomia, fiducia, identità.
          </p>
          <p data-id="element-144">
            Quando la memoria vacilla, cambia tutto: scelte quotidiane più
            lente, conversazioni spezzate, paura di sbagliare in pubblico.
            L'ansia cresce, il sonno peggiora — e peggiora anche la memoria.
          </p>
        </div>
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 sm:p-8 mb-12 rounded-r-lg" data-id="element-145">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-146">
            Segni di attenzione:
          </h3>
          <ul className="space-y-4 text-lg sm:text-xl text-gray-700" data-id="element-147">
            <li className="flex items-start" data-id="element-148">
              <span className="text-red-500 mr-3 text-2xl" data-id="element-149">•</span>
              <span data-id="element-150">
                Dimenticanze frequenti di nomi, appuntamenti, oggetti.
              </span>
            </li>
            <li className="flex items-start" data-id="element-151">
              <span className="text-red-500 mr-3 text-2xl" data-id="element-152">•</span>
              <span data-id="element-153">
                Difficoltà a seguire più istruzioni o conversazioni lunghe.
              </span>
            </li>
            <li className="flex items-start" data-id="element-154">
              <span className="text-red-500 mr-3 text-2xl" data-id="element-155">•</span>
              <span data-id="element-156">Maggiore stanchezza mentale nel pomeriggio.</span>
            </li>
            <li className="flex items-start" data-id="element-157">
              <span className="text-red-500 mr-3 text-2xl" data-id="element-158">•</span>
              <span data-id="element-159">Ansia/ruminazione su piccoli errori di memoria.</span>
            </li>
            <li className="flex items-start" data-id="element-160">
              <span className="text-red-500 mr-3 text-2xl" data-id="element-161">•</span>
              <span data-id="element-162">Sonno interrotto; risveglio non riposato.</span>
            </li>
          </ul>
        </div>
        <div className="bg-blue-50 border border-blue-200 p-6 sm:p-8 rounded-lg mb-12" data-id="element-163">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-164">
            I numeri europei
          </h3>
          <p className="text-lg sm:text-xl text-gray-700 mb-4" data-id="element-165">
            In Europa, milioni di persone sopra i 55 anni riferiscono
            dimenticanze quotidiane o lieve declino soggettivo della memoria. Le
            stime epidemiologiche indicano che:
          </p>
          <ul className="space-y-3 text-lg sm:text-xl text-gray-700" data-id="element-166">
            <li className="flex items-start" data-id="element-167">
              <span className="text-blue-600 mr-3" data-id="element-168">•</span>
              <span data-id="element-169">
                La probabilità di disturbi della memoria aumenta con l'età
                (raddoppia circa ogni 5 anni dopo i 65).
              </span>
            </li>
            <li className="flex items-start" data-id="element-170">
              <span className="text-blue-600 mr-3" data-id="element-171">•</span>
              <span data-id="element-172">
                La MCI (lieve compromissione cognitiva) interessa una quota
                significativa degli over 60 (spesso citata nell'ordine del
                10–20%).
              </span>
            </li>
            <li className="flex items-start" data-id="element-173">
              <span className="text-blue-600 mr-3" data-id="element-174">•</span>
              <span data-id="element-175">
                L'Alzheimer rappresenta la maggioranza dei casi di demenza;
                prevenzione e stile di vita contano.
              </span>
            </li>
          </ul>
          <p className="text-base text-gray-600 mt-4 italic" data-id="element-176">
            Fonti di riferimento: rapporti europei su invecchiamento e memoria
            (Alzheimer Europe, OMS).
          </p>
        </div>
        <div className="text-center" data-id="element-177">
          <h3 className="text-3xl sm:text-4xl font-bold text-gray-900" data-id="element-178">
            E se non fosse "l'età"… ma la mancanza del giusto allenamento?
          </h3>
        </div>
      </div>
    </section>;
}